import React, {useEffect, useMemo, useState} from "react";
import { Modal } from "../../SharedComponents";
import { ModalNames } from "../../../Constants/modalNames";
import { Div, Icon, Text } from "../../Kit";
import { useLanguage } from "../../../Store/modules/language";
import { Button } from "../../Kit/Button";
import { useModal } from "../../../Store/modules/modal/modal";
import { Trans, useTranslation } from "react-i18next";
import i18n from "i18next";
import { separate } from "../../../Utils";
import { Add } from "iconsax-react";
import settings from "../../../settings/settings";
import { useTheme } from "../../../Store/modules/theme";
import { setDiscountCode, useDiscountCode } from "../../../Store/modules/discountCode/discountCode";
import { DiscountCode } from "../../SubmitProcess/FinalAnalysisTest/DiscountCode/DiscountCode";
import { useForm } from "react-hook-form";
import {
  checkDiscountActions,
  useCheckDiscount,
} from "../../../Store/modules/ai/checkDiscount/checkDiscount";
import { useAppDispatch } from "../../../Hooks/useStore";
import { useBuySubService } from "../../../Store/modules/ai/buySubService/buySubService";
import { useBuySubServices } from "../../../Store/modules/ai/buySubServices/buySubServices";
import { useCheckLogin } from "../../../Store/modules/auth/checkLogin";
import {ToggleSwitch} from "../../SharedComponents/ToggleSwitch/ToggleSwitch";
import {useGetSubscriptionPlans} from "../../../Store/modules/ai/getSubscriptionPlans/getSubscriptionPlans";

export const DiscountableConfirmationModal: React.FC = () => {
  const [useWallet , setUseWallet] = useState<boolean>(false);
  const { direction } = useLanguage();
  const { modalProps, dispatchCloseModal, name: modalName } = useModal();
  const { name: theme } = useTheme();
  const { checkLoginData } = useCheckLogin();
  const { has_subscription } = checkLoginData?.data || {};
  const isModalOpen = useMemo(
    () => modalName === ModalNames.DiscountableConfirmationModal,
    [modalName],
  );
  const { register, reset, handleSubmit } = useForm<{
    discount_code: string;
  }>();
  const { title, price, onConfirm, discountType, subServices, service_id, isAllInOne } =
    modalProps || {};
  const { discountCode } = useDiscountCode();
  const { buySubServiceLoading } = useBuySubService();
  const { buySubServicesLoading } = useBuySubServices();
  const { checkDiscountData, checkDiscountLoading, dispatchCheckDiscount } = useCheckDiscount();
  const { t } = useTranslation();

  const { getSubscriptionPlansData } =
      useGetSubscriptionPlans();

  const { wallet_balance:walletBalance } = getSubscriptionPlansData?.data || {};

  const { payable_amount } = checkDiscountData?.data || {};

  const isExistCode = useMemo(
    () => discountCode?.type === discountType,
    [discountCode?.type, discountType],
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isModalOpen) {
      checkDiscountActions.loadSuccess(undefined);
      dispatch(setDiscountCode(null));
      reset();
    }
  }, [dispatch, isModalOpen]);
  const onSubmit = (data: { discount_code: string }) => {
    dispatchCheckDiscount({
      service_id,
      discount_code: data.discount_code,
      sub_services: subServices,
    });
  };

  const confirm = () => onConfirm(isNeg ? true : useWallet);

  const nb = Number(walletBalance);
  const isNeg = !Number.isNaN(nb) && nb < 0;

  const numericPrice = Number(price) || 0;
  const numericWalletBalance = Number(walletBalance) || 0;

  const basePrice = isExistCode && payable_amount != null
      ? Number(payable_amount)
      : numericPrice;

  const finalPayment = isNeg
      ? basePrice + Math.abs(numericWalletBalance)
      : useWallet
          ? Math.max(basePrice - numericWalletBalance, 0)
          : basePrice;

  return (
    <Modal
      modalName={ModalNames.DiscountableConfirmationModal}
      modalClassName="rounded-[10px] relative w-[327px]  p-0 flex flex-col justify-between items-center"
    >
      <Div
        bg="forthOpt"
        className="w-[27px] h-[27px] flex items-center justify-center pointer rounded-[50%] absolute right-[10px] top-[10px]"
        onClick={() => dispatchCloseModal()}
      >
        <Icon Component={Add} size={20} className="rotate-[45deg]" color="text" />
      </Div>
      <div dir={direction} className="flex justify-center">
        <img src={settings.logo?.[theme]} alt="logo" className="w-[81px]" />
      </div>
      <div className="py-5 text-center">
        {modalProps.title ? (
          <Trans
            i18nKey="confirmationModal.details"
            className="text-center"
            i18n={i18n}
            dir={direction}
            values={{
              price: separate(price),
              title,
              //@ts-ignore
              currency: has_subscription ? t("token") : t("toman"),
            }}
            components={{
              Price: (
                <Text
                  elementType="span"
                  fontWeight={500}
                  lineThrough={isExistCode}
                  textDecorationColor="red"
                />
              ),
              Title: <Text elementType="p" fontWeight={500} />,
              Text: <Text elementType="p" fontWeight={400} translatable={false} lineHeight={1.9} />,
            }}
          />
        ) : null}
        {isExistCode ? (
          <div className="flex items-center justify-center">
            <Text elementType="span" fontWeight={400}>
              {has_subscription ? "token" : "toman"}
            </Text>
            <Text elementType="span" fontWeight={500} translatable={false} className="mx-1">
              {separate(payable_amount)}
            </Text>
          </div>
        ) : null}
        {/*{*/}
        {/*  !has_subscription ? null*/}
        {/*      :*/}
        {/*      <>*/}
                <div className="flex justify-between items-center mt-6">
                  <Text elementType="span" translatable={false} fontSize={14}>
                    <Trans
                        i18nKey="walletBalance"
                        values={{
                          amount:Number(Math.floor(Number(walletBalance ?? 0))).toLocaleString("en-US"),
                        }}
                        components={{
                          Text: <Text elementType="span" color={isNeg ? "error" : "success"} />,
                        }}
                    />
                  </Text>
                  <ToggleSwitch
                      label=""
                      description=""
                      checked={useWallet || isNeg}
                      onChange={() => {
                        if (!isNeg) {
                          setUseWallet(!useWallet);
                        }
                      }}
                  />
                </div>
                <Div border className="mt-4"/>
                <div className="flex justify-between items-center mt-6 mb-3">
                  <Text elementType="span" translatable={false} fontSize={16}>
                    <Trans
                        i18nKey="finalPaymentGateway"
                        components={{
                          Text: <Text elementType="span" className="text-[13px]" />,
                        }}
                    />
                  </Text>
                  <div>
                    <Text elementType="span" translatable={false} fontSize={15} fontWeight={600}>{Number(Math.floor(Number(finalPayment ?? 0))).toLocaleString("en-US")}</Text>
                    <Text elementType="span" className="ms-1" fontSize={12}>toman</Text>
                  </div>
                </div>
              {/*</>*/}
        {/*}*/}
      </div>
      {has_subscription ? null : (
        <div className="flex justify-center" dir={direction}>
          <DiscountCode
            register={register}
            handleSubmit={handleSubmit(onSubmit)}
            loading={checkDiscountLoading}
            type="subService"
            reset={reset}
          />
        </div>
      )}

      <div className="flex flex-col items-center justify-center">
        <Button
          title="confirmationModal.confirmPayment"
          className=" w-[265px] h-[45px] mt-[15px]"
          textClassName="text-sm"
          loading={isAllInOne ? buySubServicesLoading : buySubServiceLoading}
          bg="primary"
          onClick={confirm}
        />
      </div>
    </Modal>
  );
};
